import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JiraHoldoutCustomData } from '@atlassian/holdout-utils';
import {
	Nav4Projects as Nav4ProjectsWithoutErrorBoundary,
	type Nav4ProjectsProps,
} from './ui/projects/Nav4Projects.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

export const Nav4Projects = (props: Nav4ProjectsProps): React.JSX.Element => (
	<UFOSegment name="nav4-sidebar-projects">
		{fg('blu-8569_add_holdout_data_to_nav_ufo_segments') && <JiraHoldoutCustomData />}
		<JSErrorBoundary
			fallback="flag"
			id="projects-section"
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
		>
			<Nav4ProjectsWithoutErrorBoundary {...props} />
		</JSErrorBoundary>
	</UFOSegment>
);
